import axios from 'axios'

import { HttpService } from '@/api/shared/http.service'
import { ApiPagedPayload, ApiPagedResponse } from '@/api/shared/types'
import { migrateFromV1ToV2, migrateFromV1ToV3 } from '@/api/shared/utils'

import { ProposalDetailed } from '../../proposals/lib/proposals.types'
import { Feed, FeedListPayload, NewsDetailed } from './news.types'

class NewsService extends HttpService {
  async getFeedList(params: ApiPagedPayload<FeedListPayload>) {
    return this.axios.get<ApiPagedResponse<Feed[]>>(
      migrateFromV1ToV2(this.getPath('/feed')),
      {
        params
      }
    )
  }

  async getNewsById(id: string) {
    try {
      const { data, status } = await this.axios.get<NewsDetailed>(
        migrateFromV1ToV3(this.getPath(`/news/${id}`))
      )
      return {
        data,
        statusCode: status
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          data: null,
          statusCode: error.response?.status
        }
      }
      throw error
    }
  }

  async getProposalItemById(id: string) {
    try {
      const { data, status } = await this.axios.get<ProposalDetailed>(
        migrateFromV1ToV3(this.getPath(`/proposals/${id}`))
      )
      return {
        data,
        statusCode: status
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          data: null,
          statusCode: error.response?.status
        }
      }
      throw error
    }
  }
}

const NewsServiceSingleton = new NewsService('/api/v1/newsproposals')
export { NewsServiceSingleton as NewsService }
